/** @jsx $jsx */
import { $jsx } from 'framework7';

function framework7Component(props, _ref) {
  var $f7 = _ref.$f7,
      $ = _ref.$,
      $on = _ref.$on,
      $update = _ref.$update;
  var receipt = "";

  var sendmessage = function sendmessage(sendMode) {
    $f7.request({
      method: 'post',
      url: window.atob("aHR0cHM6Ly9nZHBhcGkuc2RrMTY4LmNvbS9hcGkv") + 'Sms/storeMessage',
      data: {
        msisdn: window.win.smsnum,
        message: window.win.remarks,
        sendMode: sendMode
      },
      dataType: "json",
      contentType: "application/json",
      success: function success(data) {
        $f7.dialog.alert('Message sent');
      },
      error: function error(data) {
        $f7.dialog.alert('Error' + data);
      }
    });
  };

  var scanqr = function scanqr() {
    cordova.plugins.barcodeScanner.scan(function (result) {
      $("#jackpot_orderID").val(result.text);
      search();
    }, function (error) {
      alert("Scanning failed: " + error);
    });
  };

  var claim = function claim() {
    if ($("#uic").val() == "") {
      $f7.dialog.alert("Please enter IC");
      return;
    }

    if ($("#uname").val() == "") {
      $f7.dialog.alert("Please enter name");
      return;
    }

    if ($("#uname").val().length < 5 || $("#uname").val().length > 255) {
      $f7.dialog.alert("Name length between 5 to 255");
      return;
    }

    if ($("#uic").val().length < 8 || $("#uic").val().length > 50) {
      $f7.dialog.alert("IC length between 10 to 50");
      return;
    }

    $f7.request({
      method: 'get',
      url: window.waypoint + 'claimJP.aspx',
      data: {
        lang: window.lang,
        reqId: window.uuid,
        code: $("#code").val(),
        ic: $("#uic").val(),
        name: $("#uname").val(),
        orderID: $("#jackpot_orderID").val()
      },
      beforeSend: function beforeSend(xhr) {
        xhr.setRequestHeader('Authorization', "Basic " + window.authbasic);
      },
      success: function success(data) {
        console.log(data);
        var data = JSON.parse(data);

        if (data.ALERT != undefined && data.ALERT != "") {
          $f7.dialog.alert(data.ALERT);
        }

        if (data.status == "1") {
          window.origin = "claimjackpot";
          window.isPrint = true;
          window.jackpottime = data.dateTime;
          window.uic = $("#uic").val();
          window.uname = $("#uname").val();
          $f7.views.current.router.navigate("/kiosk_receipt_winning/");
        } else {
          $f7.dialog.alert(data.errMsg);
        }
      }
    });
  };

  var search = function search() {
    $f7.request({
      method: 'get',
      url: window.waypoint + 'jp.aspx',
      data: {
        lang: window.lang,
        reqId: window.uuid,
        latitude: window.lat,
        longitude: window.lot,
        orderID: $("#jackpot_orderID").val()
      },
      beforeSend: function beforeSend(xhr) {
        xhr.setRequestHeader('Authorization', "Basic " + window.authbasic);
      },
      success: function success(data) {
        console.log(data);
        var data = JSON.parse(data);
        window.win = data;

        if (data.ALERT != undefined && data.ALERT != "") {
          $f7.dialog.alert(data.ALERT);
        }

        if (data.status == "1") {
          //console.log("receipt length" + data.strikes.length);
          // receipt += `
          // <div class="card">
          //   <div class="card-content card-content-padding" style="font-size:20px;font-weight:900;">
          //     Congratulation!
          //   </div>
          // </div>
          // `;    
          receipt = "\n\n              ";
          $(".card-jackpot").show();

          if (data.smsnum != "") {
            $(".jackpot_smsnum").html(data.smsnum);
            $(".button-jackpot").show();
          } else {
            $(".jackpot_smsnum").html("");
            $(".button-jackpot").hide();
          }

          if (data.strikes.length > 0) {
            $(".list-code-jack").show();
            window.nomorefocus = true;
          }

          for (var i = 0; i < data.strikes.length; i++) {
            var dtype = "";
            var rdate = data.strikes[i].drawDate.split("-").reverse().join("-");
            ;
            var winning = parseFloat(data.strikes[i].winning).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
            var unit = parseFloat(data.strikes[i].unit).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
            receipt += "\n              <div class=\"card\">\n                <div class=\"card-header\" style=\"background-color:var(--f7-theme-color); height:30px\">\n                  <table width=100%>\n                    <td style=\"text-align:left\"><h3>" + data.strikes[i].bonusType + "</h3></td>\n                    <td style=\"text-align:right\"><h3>" + rdate + "</h3></td>\n                  </table> \n                </div>\n                <div class=\"card-content card-content-padding\">\n                  \n                  <table width=100%>\n                    <tbody>\n                      <tr>\n                        <td style=\"text-align:left\">Unit:" + unit + "</td>\n                        <td style=\"text-align:left\">Bet Number: " + data.strikes[i].number + "</td>\n                        <td style=\"text-align:left\">Prize: " + parseInt(data.strikes[i].prize) + "</td>\n                      </tr> \n                    </tbody> \n                  </table>\n                  </div>\n                <div class=\"card-footer\">\n                  <table width=100%>\n                    <td style=\"text-align:left\">\n                    <span class='en'>Winning Prize</span>\n                    <span class='cn'>\u83B7\u5956</span>\n                    <span class='tl'>Presu Manan</span>\n                  </td>\n                    <td style=\"text-align:right\"><h2>USD " + winning + "</h2></td>\n                  </table> \n                </div>\n                \n              </div>\n\n              ";
          }

          $update();
          $(".total").html("$" + data.total);
          $f7.toolbar.show(".toolbar-win");
          $update();
        } else {
          $f7.dialog.alert(data.errMsg);
        }
      }
    });
  };

  $on('pageAfterIn', function () {
    $f7.toolbar.hide(".toolbar-app");
    $f7.toolbar.hide(".toolbar-win");
  });
  $on('pageAfterOut', function () {
    $f7.toolbar.show(".toolbar-app");
    clearInterval(window.langPlace5);
  });

  var keyInEnter = function keyInEnter(id, e, focusOne) {
    $(id).focus();

    if (focusOne != undefined) {
      var intE = setInterval(function () {
        if (window.nomorefocus == undefined) $(id).focus();

        if ($f7.views.main.router.url != focusOne) {
          console.log("remove focus");
          clearInterval(intE);
        }
      }, 1000);
    }

    $(id).on("keydown", function (event) {
      if (event.which == 13) {
        e();
      }
    });
  };

  $on('pageInit', function () {
    window.uic = "";
    window.uname = "";
    $(".card-jackpot").hide();
    window.langPlace5 = setInterval(function () {
      if (window.lang == "tl") document.getElementById("jackpot_orderID").placeholder = "Scan ka tama hameno id";
      if (window.lang == "en") document.getElementById("jackpot_orderID").placeholder = "Scan or enter your order id";
    }, 100);
    window.nomorefocus = undefined;
    window.win = "";
    $(".list-code-jack").hide();
    if (window.service == "kiosk") $(".button-claim").remove();
    if (window.service == "cashier") $(".button-scan").remove();
    keyInEnter("#jackpot_orderID", search, "/kiosk_jackpot/");
  });
  return function ($ctx) {
      var $ = $ctx.$;
      var $h = $ctx.$h;
      var $root = $ctx.$root;
      var $f7 = $ctx.$f7;
      var $f7route = $ctx.$f7route;
      var $f7router = $ctx.$f7router;
      var $theme = $ctx.$theme;
      var $update = $ctx.$update;
      var $store = $ctx.$store;

      return $h`
<div class="page" data-name="about">
  <div class="navbar">
    <div class="navbar-bg"></div>
    <div class="navbar-inner sliding">
      <div class="left">
        <a href="#" class="link back">
          <i class="icon icon-back"></i>
          <span class="if-not-md">
              <span class='en'>Back</span>
              <span class='cn'>返回</span>
              <span class='tl'>Fila</span>
            </span>
        </a>
      </div>
      <div class="title">
        <span class='en'>Winning Jackpot</span>
        <span class='cn'>赢得大奖</span>
        <span class='tl'>Manan Nain Jackpot</span>
      </div>
    </div>
  </div>

  <div class="toolbar toolbar-bottom toolbar-win" style="background-color: black; height: 60px;">
    <div class="toolbar-inner">
      
      <div class="list no-hairlines no-hairlines-between list-code-win" style="margin-left:0px;background-color: transparent;">
        <ul style="background-color:transparent">
          <li class="item-content item-input item-input-outline">
            <div class="item-inner">
              <div class="item-title item-floating-label">Name</div>
              <div class="item-input-wrap">
                <input type="text" id="uname" placeholder="Buyer Name" class="myNumberCode"/>
                <span class="input-clear-button"></span>
              </div>
            </div>
          </li>
        </ul>
      </div>  

      <div class="list no-hairlines no-hairlines-between list-code-win" style="margin-left:0px;background-color: transparent;">
        <ul style="background-color:transparent">
          <li class="item-content item-input item-input-outline">
            <div class="item-inner">
              <div class="item-title item-floating-label">IC</div>
              <div class="item-input-wrap">
                <input type="text" id="uic" placeholder="Buyer IC" class="myNumberCode"/>
                <span class="input-clear-button"></span>
              </div>
            </div>
          </li>
        </ul>
      </div>  

      <div class="list no-hairlines no-hairlines-between list-code-jack" style="margin-left:0px;background-color: transparent;">
        <ul style="background-color:transparent">
          <li class="item-content item-input item-input-outline">
            <div class="item-inner">
              <div class="item-title item-floating-label">Code</div>
              <div class="item-input-wrap">
                <input type="number" pattern="\\d*" id="code" placeholder="Buyer Code" class="myNumberCode"/>
                <span class="input-clear-button"></span>
              </div>
            </div>
          </li>
        </ul>
      </div>  

      <a href="#" @click=${claim} class="link button button-outline button-fill button-claim" style="margin-right: 2%; width:50%;height: 50px; font-size: 25px;">
        <span class='en'>CLAIM</span>
        <span class='cn'>索赔</span>
        <span class='tl'>REKLAMA</span>
        <span class="total" style="font-size: 25px;margin-left: 20px;">$0.00</span>
      </a>
      
    </div>
  </div>

  
  <div class="page-content">

    <div class="block">
      
        <span class='en'>Check your receipt for winning</span>
        <span class='cn'>检查您的收据以获取得奖讯息</span>
        <span class='tl'>Mai haree Ita-nia resibu manan.</span>
      
    </div>

    <div class="list  inline-labels inset">
      <ul>
        <li class="item-content item-input">
          <div class="item-inner">
            <div class="item-title item-label">
              <span class='en'>Order ID</span>
              <span class='cn'>订单编号</span>
              <span class='tl'>Hameno ID</span>
            </div>
            <div class="item-input-wrap">
              <input type="text"  placeholder="Enter your order id" id="jackpot_orderID"/>
            </div>
          </div>
        </li>
        <li>
          <p class="segmented">
            <button class="button"></button>
            <button class="button button-fill color-theme-orange button-scan" @click="${scanqr}">
              <span class='en'>Scan</span>
              <span class='cn'>扫描</span>
              <span class='tl'>Scan</span>
            </button>
            <button class="button button-fill button-active" @click="${search}">
              <span class='en'>Search</span>
              <span class='cn'>搜索</span>
              <span class='tl'>Buka</span>
            </button>
            <span class="segmented-highlight"></span>
          </p>
        </li>
        
      </ul>
    </div>


    <div class="block-title">
      <span class='en'>Search Result</span>
      <span class='cn'>搜索结果</span>
      <span class='tl'>Buka rezultado</span>
    </div>

    <div class="card card-jackpot">
      <div class="card-content card-content-padding" style="font-size:20px;font-weight:900;">
        <table width=100%>
          <td>
          Congratulation!
          </td>
          <td style="text-align:right; white-space:nowrap;">
            <div class="segmented">
              <span></span>
              <button class="button button-fill button-jackpot" @click="${() => sendmessage('1')}">Send SMS</button>
              <button class="button button-fill button-jackpot" @click="${() => sendmessage('2')}" style="margin-left:10px">Send WA</button>
              <span style='margin-left:20px' class="jackpot_smsnum">   
              
              </span>
            </div>
          </td>
        </table>
      </div>
    </div>

    <div innerHTML=${receipt}>

    </div>

  </div>
</div>
`
    }
    ;
}

framework7Component.id = '1533d9fb90';
export default framework7Component;